import { combineReducers } from 'redux';

export default class Registry {
  constructor(baseReducers, sagaMiddleware) {
    this.baseReducers = baseReducers;
    this.asyncReducers = {};
    this.sagaMiddleware = sagaMiddleware;
    this.currentSagas = {};
  }

  injectReducers(newReducer) {
    // We use '.default' here as it is a result of mixing ES6 'export default' syntax and node
    // 'system.import' syntax. When using 'system.import' on a module that is exported as
    // 'export default', the imported module is accessible through its '.default' property.
    this.asyncReducers[newReducer.default.reducerName] = newReducer.default;
    this.store.replaceReducer(combineReducers({ ...this.baseReducers, ...this.asyncReducers }));
  }

  injectSagas(newSagas) {
    // Makes sure the same saga is not injected twice. Apparently this is a known issue when
    // code splitting sagas. See https://github.com/react-boilerplate/react-boilerplate/issues/1434.
    if (!this.currentSagas[newSagas.default.name]) {
      this.currentSagas[newSagas.default.name] = newSagas.default;
      this.sagaMiddleware.run(newSagas.default);
    }
  }
}
